export default [
    {
        path: '/various-documents',
        name: 'variousDocumentsList',
        component: () => import(/* webpackChunkName: "various-documents" */ '../views/Categories.vue'),
        props: true,
    },
    {
        path: '/various-documents/:category',
        name: 'categoryVariousDocumentsList',
        component: () => import(/* webpackChunkName: "various-documents" */ '../views/List.vue'),
        props: true,
    },
]